import { NgModule } from '@angular/core';
import { AuthGuard } from './auth.guard';
import { CandidateGuard } from './candidate.guard';
import { EmployerGuard } from './employer.guard';

@NgModule({
    providers: [AuthGuard, CandidateGuard, EmployerGuard],
})
export class UserModule {}
